import {
  Card, Heading, VStack, Tabs, Box,
} from '@chakra-ui/react';
import React, { useState } from 'react';

import AddGroups from './add-groups';
import AddUsers from './add-users';

const AddMembersCard = ({ editGroupId }: { editGroupId?: string }) => {
  const [activeTab, setActiveTab] = useState('users');

  const tabProps = {
    h: '60px',
    _selected: {
      '--indicator-color': 'colors.marleyRed.500',
      '--indicator-thickness': '4px',
    },
  };

  return (
    <VStack align="flex-start" h="45vh">
      <Heading h={8} size="md" display="flex" alignItems="center">Add Members</Heading>
      <Card.Root
        w="100%"
        flex="1"
        display="flex"
        flexDirection="column"
        overflow="hidden"
      >
        <Tabs.Root
          value={activeTab}
          onValueChange={(details: { value: string }) => setActiveTab(details.value)}
          variant="line"
          fitted
          display="flex"
          flexDirection="column"
          h="100%"
        >
          <Box bg="white" flexShrink={0}>
            <Tabs.List>
              <Tabs.Trigger
                {...tabProps}
                value="users"
                data-testid="dialog-users-tab"
              >
                Users
              </Tabs.Trigger>
              <Tabs.Trigger
                {...tabProps}
                value="groups"
                data-testid="dialog-groups-tab"
              >
                Groups
              </Tabs.Trigger>
            </Tabs.List>
          </Box>
          <Box flex="1" overflow="hidden">
            <Tabs.Content pt={0} value="users" h="100%">
              <AddUsers />
            </Tabs.Content>
            <Tabs.Content pt={0} value="groups" h="100%">
              <AddGroups editGroupId={editGroupId} />
            </Tabs.Content>
          </Box>
        </Tabs.Root>
      </Card.Root>
    </VStack>
  );
};

export default AddMembersCard;
